//closes details summary upon mouse cursor leave
const imitationDropDownsContents = document.querySelectorAll(".sys-pack");
imitationDropDownsContents.forEach(imitationDropDownsContent => {
    imitationDropDownsContent.addEventListener('mouseleave', function(event){
        const imitationDropDowns = document.querySelectorAll(".imatation_dropdown");
        imitationDropDowns.forEach(imitationDropDown => {
            imitationDropDown.removeAttribute('open');
        });
    });
});

// parses the html for the addon product description displays
function buildAddOnItemDisplayHTML(item, itemCounter) {

    const html = [];
    //grab the hidden element that contains a addon products description data
    const description = document.getElementById('hidden_description' + itemCounter);

    // pushes each string into the array
    html.push(
        '<div class="product-title-container">',
            '<h2 class="product-title"><stong>',
                item.title,
            '</strong></h2>',
        '</div>',
        '<div class="product-image-container">',
            '<img class="product-image" src="', item.featured_image, '"/>',
        '</div>',
        '<div class="product-description-container">',
            '<p class="product-description">',
                description.innerHTML,
            '</p>',
        '</div>'
    )
    // concatenates the array together and returns the html string
    return html.join('');
}

// makes an addon product details visible
// function focusInEvents(itemCounter, event) {
//     // console.log('hello');
    
//     const addOnProductDetails = document.getElementById('product-container-' + itemCounter);
//     // console.log('hello');
//     switch (addOnProductDetails.style.visibility) {
//         case "hidden":
//             addOnProductDetails.style.display = "block";
//             addOnProductDetails.style.visibility = "visible";
//             break;
//         // case "visible":
//         //     // addOnProductDetails.addEventListener("click", focusOutEvents.bind(null, itemCounter));
//         //     focusOutEvents(itemCounter, null);
//         //     break;

//     }
//     return null;
// }

// hides an addon products details for desktop
function focusOutEvents(itemCounter, event) {
   
    const addOnProductDetails = document.getElementById('product-container-' + itemCounter);
    if(addOnProductDetails.style.visibility === "visible"){
        addOnProductDetails.style.display = "none";
        addOnProductDetails.style.visibility = "hidden";
    }
}

// hides an addon products details for mobile
function focusOutMobileEvents(itemCounter, event) {
   
    const addOnProductDetails = document.getElementById('product-container-' + itemCounter);
    if(!event.targetTouches[0].target.closest('.product-display-container') && !event.targetTouches[0].target.closest('.imatation_dropdown_details_content')){
        addOnProductDetails.style.display = "none";
        addOnProductDetails.style.visibility = "hidden";
    }

    if(!event.targetTouches[0].target.closest('.imatation_dropdown_details_content')) {
        const imitationDropDowns = document.querySelectorAll(".imatation_dropdown");
        imitationDropDowns.forEach(imitationDropDown => {
            imitationDropDown.removeAttribute('open');
        });
    }
    // for(let i = 0; i < event.targetTouches.length; i++) {
    //     console.log(`touchpoint[${i}].target = ${event.targetTouches[i].target.className}`);
    // }
}


document.addEventListener('DOMContentLoaded', () => {
    var sectionCounter = 0;
    var dropDownCounter = 0;
    var itemCounter = 0;
    var itemPerSectionCounter = 0;
    var cntDivCounter = 0;
    let hiddenDescriptionTotalPerSection = [];
    let cntDiv = [];

    const hiddenItemElements = document.querySelectorAll('.hidden_item');
    const hiddenDescriptionElements = document.querySelectorAll('.hidden_description');
    const sysPackElements = document.querySelectorAll('.sys-pack');
    const dropDownElements = document.querySelectorAll('.imatation_dropdown_container');
    const imitationDropDownWrappers = document.querySelectorAll('.imatation_dropdown_product_option_wrapper');
    const quantityInputs = document.querySelectorAll('.imatation_dropdown_product_option_quantity__input');
    const productOptions = document.querySelectorAll('.imatation_dropdown_product_option');

    sysPackElements.forEach(sysPackElement => {
        sysPackElement.id = "package-content-" + sectionCounter;
        hiddenDescriptionTotalPerSection.push(document.querySelectorAll("#" + sysPackElement.id + ">.hidden_description").length);
        // itemCounter = 0;
        // var items = [];
        sectionCounter++;
    });

    sectionCounter = 0;

    hiddenDescriptionElements.forEach(hiddenDescriptionElement => {
        hiddenDescriptionElement.id = "hidden_description" + itemCounter;
        itemCounter++;
    });

    itemCounter = 0;
    
    dropDownElements.forEach(dropDownElement => {
        dropDownElement.id = "drop-down-" + dropDownCounter;
        dropDownCounter++;
    });

    dropDownCounter = 0;

    imitationDropDownWrappers.forEach(imitationDropDownWrapper => {
        imitationDropDownWrapper.htmlFor = (itemCounter + 1).toString();
        imitationDropDownWrapper.id = "wrapper_" + itemCounter;
        itemCounter++;
    });

    itemCounter = 1;

    quantityInputs.forEach(quantityInput => {
        quantityInput.name = "items[" + itemCounter + "][quantity]";
        itemCounter++;
    });

    itemCounter = 1;

    productOptions.forEach(productOption => {
        productOption.name = "items[" + itemCounter + "][id]";
        productOption.id = itemCounter;
        itemCounter++;
    });

    itemCounter = 0;

    hiddenItemElements.forEach( itemElement => {
        const item = JSON.parse(itemElement.innerHTML);

        cntDiv.push(document.createElement('div'));
        cntDiv[cntDivCounter].className = 'product-display-container';
        cntDiv[cntDivCounter].id = 'product-container-' + itemCounter;

        const allNodes = Array.from(cntDiv[cntDivCounter].childNodes);
        cntDiv[cntDivCounter].innerHTML = buildAddOnItemDisplayHTML(item, itemCounter);
        cntDiv[cntDivCounter].style.display = "none";
        cntDiv[cntDivCounter].style.visibility = "hidden";

        cntDivCounter++;
        itemCounter++;
    });

    cntDivCounter = 0;
    hiddenDescriptionTotalPerSection.forEach(total => {
        console.log(total);
        for(var x = 0; x < total; x++){
            document.getElementById("package-content-" + sectionCounter).insertBefore(cntDiv[cntDivCounter], document.getElementById("drop-down-" + dropDownCounter));
            cntDivCounter++;
        }
        cntDivCounter = total;
        sectionCounter++;
        dropDownCounter++;
    });

    var addOnProductContainers = document.querySelectorAll('.product-display-container');
    var addMainContainer = document.getElementById("MainContent");
    itemCounter = 0;
    addOnProductContainers.forEach(addOnProductContainer => {
        // console.log('hello'); mouseleave
        addOnProductContainer.addEventListener("mouseleave", focusOutEvents.bind(null, itemCounter));
        addMainContainer.addEventListener("touchstart", focusOutMobileEvents.bind(null, itemCounter));
        itemCounter++;
    });
    
});

var itemCounter = 0;
var loopCount = 0;
const idNum = [];
var numCheck = 0;
var previousSelectedProduct = null;
var addOnProductDetails = null;

var addOnProducts = document.querySelectorAll('.imatation_dropdown_product_option_wrapper');
function addListeners() {
    addOnProducts.forEach(addOnProduct => {
        idNum.push(itemCounter);
        itemCounter++;
        addOnProduct.addEventListener("click", function(event) {
            idNum.forEach((num) => {
                if (event.currentTarget.matches('#wrapper_' + num + '.imatation_dropdown_product_option_wrapper')) {
                    const action = event.currentTarget.getAttribute("data-action");
                    addOnProductDetails = document.getElementById('product-container-' + num);
                    numCheck = handleAction(action, event, addOnProductDetails, numCheck);
                    
                    if(numCheck == 1 && previousSelectedProduct == addOnProductDetails) {
                        previousSelectedProduct.style.visibility = "hidden";
                        previousSelectedProduct.style.display = "none";
                        previousSelectedProduct = null;
                    }
                    else if(numCheck == 1 && previousSelectedProduct != addOnProductDetails && previousSelectedProduct != null) {
                        previousSelectedProduct.style.visibility = "hidden";
                        previousSelectedProduct.style.display = "none";
                        previousSelectedProduct = null;
                    }
                    else if(previousSelectedProduct == null && numCheck != 1){
                        // previousSelectedProduct = null;
                    }
                    else {
                        previousSelectedProduct = addOnProductDetails;
                    }
                }
            });
        }); 
    });
}

function handleAction(actionType, event, addOnProductDetails, numCheck) {
    
    switch (actionType) {
        case "click":
            // const addOnProductDetails = document.getElementById('product-container-' + num);
            switch (addOnProductDetails.style.visibility) {
                case "hidden":
                    if(numCheck == 0){
                        addOnProductDetails.style.display = "block";
                        addOnProductDetails.style.visibility = "visible";
                        return 1;
                    }
                    return 0;
                case "visible":
                    if(numCheck == 0){
                        addOnProductDetails.style.display = "none";
                        addOnProductDetails.style.visibility = "hidden";
                        return 1;
                    }
                    return 0;
            }
    }
}

addListeners();

// addOnProducts.forEach(addOnProduct => {
//     addOnProduct.addEventListener("click", focusInEvents.bind(null, itemCounter));
//     addOnProduct.addEventListener("click", focusOutEvents.bind(null, itemCounter));
//     // addOnProduct.addEventListener("click", focusOutEvents.bind(null, itemCounter));
//     itemCounter++;
// })








